import { useRef } from "react";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useModal } from "context/ModalContext";
import { getButtonsCancelOk } from "context/helpers/helperModalContext";
import { useAuth } from "context/AuthContext";
import { useToast } from "context/ToastContext";
import * as apiProfile from "api/apiProfile";

const useSetTelegram = () => {
    const { t } = useTranslation();
    const { showDlg } = useModal();
    const { auth, updateAuthUser } = useAuth();
    const { showToast } = useToast();
    const refForm = useRef();

    const openSetTelegram = () => {
        const p = {
            buttons: [...getButtonsCancelOk(t)],
            type: "info",
            title: t("UserDropDown.telegramDlgTitle"),
            text: (
                <>
                    <p className="text-muted mb-3">{t("UserDropDown.telegramDlgDesc")}</p>
                    <Formik
                        initialValues={{
                            telegram: auth.user.telegram || "",
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            const telegram = values.telegram.replace(/^@/, "").trim();
                            const saved = await apiProfile.setTelegram(telegram);
                            if (saved === false) {
                                showToast(t("common:messError"), "danger");
                                setSubmitting(false);
                                return;
                            }
                            updateAuthUser({ telegram: saved });
                            showToast(t("UserDropDown.telegramSaved"), "success");
                            showDlg(false);
                        }}
                    >
                        {({ handleSubmit, values, setFieldValue }) => (
                            <form ref={refForm} onSubmit={handleSubmit}>
                                <Form.Group>
                                    <label className="form-label text-muted">{t("Users.fieldUserTelegram")}</label>
                                    <input
                                        id="inputTelegramAccount"
                                        className="form-control"
                                        type="text"
                                        maxLength={101}
                                        placeholder="@username"
                                        value={values.telegram ? `@${values.telegram.replace(/^@/, "")}` : ""}
                                        onChange={(e) => {
                                            const val = e.currentTarget.value.replace(/^@/, "").trim();
                                            setFieldValue("telegram", val);
                                        }}
                                    />
                                    <input type="submit" className="d-none" />
                                </Form.Group>
                            </form>
                        )}
                    </Formik>
                </>
            ),
            idFirstFocus: "inputTelegramAccount",
        };

        p.buttons[0].handleClick = () => showDlg(false);
        p.buttons[1].handleClick = (e) => {
            e.preventDefault();
            if (refForm.current?.reportValidity()) {
                refForm.current?.requestSubmit?.();
            }
        };

        showDlg(p);
    };

    return { openSetTelegram };
};

export default useSetTelegram;
